<template>
  <div class="news">
    <banner title="新闻资讯" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav">
          <div
            class="content-nav-btn"
            :class="{ 'content-nav-active': newstype == 1 }"
            @click="newstype = 1"
          >
            <span>智慧养老</span>
          </div>
        </div>

        <div class="content-nav-item">
          <div class="item-list" v-for="(item, index) in newsList" :key="index">
            <div class="item-img">
              <img :src="item.Img" alt="" />
            </div>
            <p class="item-list-title">{{ item.Title }}</p>
            <p class="item-list-content">{{ item.Content }}</p>
            <div class="item-list-more">
              <router-link
                class="text-decoration"
                :to="{ name: 'YaoPinDetails', params: { id: item.Id } }"
              >
                <img src="@/assets/img/sanjiao.png" />
                <span>查看详情</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
export default {
  name: "news",
  components: {
    Banner,
  },
  data() {
    return {
      loading: false,
      newsList: [
        {
          Id: "1",
          Title: "三九999颗粒感冒 冲剂头痛发热鼻塞流涕咽痛解热镇痛",
          Img: require("@/assets/img/YaoPin1.png"),
          CreateTime: "2024-04-16 17:51",
          Content:
            "该产品为浅棕色至深棕色的颗粒，味甜、微苦。具有解热镇痛的功效，用于因感冒引起的头痛，发热，鼻塞，流涕，咽痛等症状。每盒含9包，每包袋装10g。",
        },
        {
          Id: "2",
          Title: "止咳糖浆",
          Img: require("@/assets/img/YaoPin2.png"),
          CreateTime: "2024-04-22 18:05",
          Content:
            "止咳糖浆主要用于止咳，化痰。适用于感冒、咳嗽、多痰、支气管性气喘等症。属于处方药。 咳嗽是呼吸系统受到刺激时产生的一种防御性反射活动。轻微的咳嗽能清除气管内的痰液与异物，可自然缓解，一般不需服用止咳药；强烈而频繁的咳嗽，尤其是干咳，可能使病情加重而引起并发症，因此需要在治疗的同时加用止咳药。",
        },
        {
          Id: "3",
          Title: "黄莲",
          Img: require("@/assets/img/YaoPin3.png"),
          CreateTime: " 2024-06-07 15:44",
          Content:
            "惯和购物需求发生了显著变化，更注重个性化、便捷化和体验化。这使得传统实体店在吸引年轻消费者方面面临挑战。市场需求旺盛：随着社会老龄化的加速推进，居家养老成为越来越多老年人的首选。他们对居家养老服务的需求日益增长，为产业发展提供了广阔的市场空间。政策支持力度加大：为应对老龄化挑战，政府出台了一系列政策措施，鼓励和支持居家养老产业的发展。这些政策为居家养老服务机构提供了更多的发展机会和优惠政策。创新服务模式不断涌现：随着科技的进步，越来越多的创新服务模式应用于居家养老领域，如智能养老设备、远程医疗服务等。这些创新服务模式不仅提升了服务质量，也满足了老年人的多样化需求。",
        },
      ],
      newstype: 1,
    };
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
  height: 100%;
}
.news {
  width: 100%;
  height: 100%;
  background-color: rgb(255, 118, 64, 0.9);
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid red;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;

        &-btn {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #15669e;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            height: 210px;
          }
          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
</style>